import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import ConfirmQuotationModal from './confirm-quotation-modal/ConfirmQuotationModal'
import DeclineQuotationModal from '../decline-quotation-modal/DeclineQuotationModal'
import OwnerCurrentActionFooterContainer from '../OwnerCurrentActionFooterContainer'
import { IUploadQuotationProps } from '../upload-quotation-modal/UploadQuotationModal'
import { CompanyInformationClientProposalFragment } from '../../../../../../../lib/graphql'
import { Button } from '../../../../../../../shadcn/components/ui/button'
import { IProposalInteractionsProps } from '../../../../../../organisms/proposal/Proposal'
import PingPongButton from '../../../../../../organisms/proposal/proposal-cta/buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../../../../organisms/proposal/proposal-cta/utils/ping-pong-button-type.enum.ts'

const OwnerCanConfirmQuotationFooter = ({
  clientProposal,
  ownerActions,
  uploadQuotationData,
}: {
  clientProposal: CompanyInformationClientProposalFragment
  ownerActions: IProposalInteractionsProps['ownerActions']
  uploadQuotationData?: IUploadQuotationProps
}) => {
  const [isOpenConfirmQuotationModal, setIsOpenConfirmQuotationModal] =
    useState(false)
  const [isOpenDeclineQuotationModal, setIsOpenDeclineQuotationModal] =
    useState(false)

  const ownerUploadedQuotation = ownerActions?.ownerUploadedQuotation
  const ownerConfirmedQuotation = ownerActions?.ownerConfirmedQuotation
  const ownerDeclinedQuotation = ownerActions?.ownerDeclinedQuotation

  if (
    !ownerUploadedQuotation ||
    !ownerConfirmedQuotation ||
    !ownerDeclinedQuotation ||
    !clientProposal.clientPricingItems
  ) {
    return null
  }

  return (
    <OwnerCurrentActionFooterContainer>
      {clientProposal.clientPricingItems.length > 0 ? (
        <PingPongButton
          dataTestId='confirm-quotation-button'
          label={
            <FormattedMessage
              id='ui.ownerCurrentActionButton.confirmQuote'
              defaultMessage='Valider le devis'
            />
          }
          type={PingPongButtonTypeEnum.CONFIRM}
          onClick={() => setIsOpenConfirmQuotationModal(true)}
        />
      ) : (
        <Button disabled={true}>Valider le devis</Button>
      )}

      <PingPongButton
        label={
          <FormattedMessage
            id='ui.ownerCurrentActionButton.declineBooking'
            defaultMessage='Refuser la demande'
          />
        }
        type={PingPongButtonTypeEnum.DECLINED_BY_OWNER}
        onClick={() => setIsOpenDeclineQuotationModal(true)}
      />

      {isOpenConfirmQuotationModal && (
        <ConfirmQuotationModal
          isOpen={isOpenConfirmQuotationModal}
          setIsOpen={setIsOpenConfirmQuotationModal}
          clientProposal={clientProposal}
          ownerConfirmedQuotation={ownerConfirmedQuotation}
          uploadQuotationData={uploadQuotationData}
        />
      )}
      {isOpenDeclineQuotationModal && (
        <DeclineQuotationModal
          isOpenModal={isOpenDeclineQuotationModal}
          setIsOpenModal={setIsOpenDeclineQuotationModal}
          ownerDeclinedQuotation={ownerDeclinedQuotation}
        />
      )}
    </OwnerCurrentActionFooterContainer>
  )
}

export default OwnerCanConfirmQuotationFooter
